import type { IconDefinition } from '../index.tsx';

export const iconSort: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconSort',
  icon: [
    16,
    17,
    [],
    '',
    'M5.90383 6.06063L5.90383 4.64642L10.1465 0.403778L14.3891 4.64642V6.06063H11.1465V8.30327H9.14647L9.14647 6.06063L5.90383 6.06063Z M10.3891 10.6464L10.3891 12.0606L6.14645 16.3033L1.90381 12.0606V10.6464H5.14645L5.14645 8.40378H7.14645L7.14645 10.6464L10.3891 10.6464Z',
  ],
};
